import api from '../api';

/**
 * Sends a support ticket email to the backend using the support template.
 * @param {Object} params
 * @param {string} params.firstName
 * @param {string} params.lastName
 * @param {string} params.schoolName
 * @param {string} params.email
 * @param {string} params.reason
 * @returns {Promise}
 */
export async function sendSupportTicket({ firstName, lastName, schoolName, email, supportType, additionalInformation }) {
    return api.post('/api/public/support-ticket', {
        firstName,
        lastName,
        schoolName,
        email,
        supportType,
        additionalInformation,
    });
}
